import { useTheme } from '../context/ThemeContext';

function SunIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="4.2" fill="currentColor" />
      <path
        d="M12 2.5v2.2M12 19.3v2.2M4.6 4.6l1.6 1.6M17.8 17.8l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.6 19.4l1.6-1.6M17.8 6.2l1.6-1.6"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20.5 14.6A8.5 8.5 0 019.4 3.5a8.5 8.5 0 1011.1 11.1z" fill="currentColor" />
    </svg>
  );
}

/** Light/dark toggle. On = dark. Defaults to the system setting (see ThemeContext). */
export default function ThemeSwitch() {
  const { theme, toggleTheme, colors } = useTheme();
  const dark = theme === 'dark';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      aria-label="Dark mode"
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={toggleTheme}
      style={{
        position: 'relative', flexShrink: 0,
        width: '52px', height: '28px', padding: 0,
        borderRadius: '999px', border: `1px solid ${colors.border}`,
        background: dark ? '#1d2438' : '#ece6fc',
        cursor: 'pointer', transition: 'background 0.25s',
      }}
    >
      <span
        style={{
          position: 'absolute', top: '2px', left: dark ? '26px' : '2px',
          width: '22px', height: '22px', borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: dark ? colors.accent : '#ffffff',
          color: dark ? '#0a0e18' : '#f59e0b',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
          transition: 'left 0.25s, background 0.25s',
        }}
      >
        {dark ? <MoonIcon /> : <SunIcon />}
      </span>
    </button>
  );
}
